/**
 * @fileoverview Entity Picker label item presentation component
 */
goog.declareModuleId('yext.ui.components.entitypicker.LabelItem');

export function LabelItem(props) {
  return (
    <li className="uep-label-item">
      <button type="button" onClick={props.onClick} className="uep-item">
        {props.label.label}
        {props.label.isInternal
          && <span className="uep-internal"/>
        }
      </button>
    </li>
  );
}
